export interface NavItem {
  label: string;
  href: string;
  icon?: string;
}

export const siteInfo = {
  name: '吃瓜群',
  description: '吃瓜群众免费吃瓜与在线爆料大全，网红塌房黑料实时追踪聚集地。覆盖网红塌房、博主反差视频、明星聊天记录泄露等黑料大瓜，每日实时更新热门吃瓜事件。',
  qqGroupNumber: '88888888',
  email: 'hello@sxthpxzx.cn',
  foundedYear: '2023',
  totalExposures: '12,800+',
};

export const footerLinks = {
  categories: [
    { label: '网红塌房', href: '/category/wanghong-tafang' },
    { label: '明星黑料', href: '/category/mingxing-bagua' },
    { label: '反差视频', href: '/category/fancha-shipin' },
    { label: '聊天记录', href: '/category/liaotian-jilu' },
    { label: '视频爆料', href: '/category/shipin-bagua' },
    { label: '圈子热点', href: '/category/quanzi-redian' },
  ],
  about: [
    { label: '关于我们', href: '/about' },
    { label: '品牌介绍', href: '/about#brand' },
    { label: '口碑信誉', href: '/about#reputation' },
    { label: '联系方式', href: '/about#contact' },
  ],
  legal: [
    { label: '用户协议', href: '/terms' },
    { label: '隐私政策', href: '/privacy' },
    { label: '免责声明', href: '/disclaimer' },
    { label: '投诉举报', href: '/report' },
  ],
};